import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LoadingBarService } from '@ngx-loading-bar/core';

import Swal from 'sweetalert2';

import {
  HeaderService,
  ServicesService,
  FiltersService
} from '../../../shared';
import { Router } from '@angular/router';

@Component({
  selector: 'app-services-new',
  templateUrl: './services-new.component.html',
  styleUrls: ['./services-new.component.scss']
})
export class ServicesNewComponent implements OnInit {
  title = "NOVO SERVIÇO";
  subtitle = "Utilize os campos abaixo para cadastrar um novo serviço";
  urlBack = "/panel/services/list";

  newService = new FormGroup({
    cdFornecedor: new FormControl(''),
    lojas: new FormControl([]),
    cdArea: new FormControl(''),
    cdProduto: new FormControl(''),
    vlMaxManutencao: new FormControl(0),
    vlMaxMaterial: new FormControl(0),
    cdsImpostoSap: new FormControl(''),
    dsComplementoSap: new FormControl(''),
    dsOperacaoSap: new FormControl(''),
    dsProjetoSap: new FormControl(''),
    flNovaLoja: new FormControl('0')
  });

  selectedStores = [];

  providersArr;

  relatedEquipments = [
    {
      cdArea: "",
      cdProduto: "",
      vlMaxManutencao: 0,
      vlMaxMaterial: 0
    }
  ];

  constructor(
    private headerService: HeaderService,
    private servicesService: ServicesService,
    private loadingBarService: LoadingBarService,
    private filtersService: FiltersService,
    private router: Router
  ) { }

  ngOnInit() {
    this.headerService.changeTitle('Cadastro de novo serviço');

    this.headerService.changeSubtitle('');

    this.headerService.changeDatePicker(false);

    this.filtersService.listProviders().subscribe((response) => {
      this.providersArr = response['data'];
    });
  }

  limiteCaractere(evento, limite) {
    const limit = +limite;
    if (evento.target.value.length == limit) evento.preventDefault();
 }

  storesValues(arr) {
    this.newService.patchValue({
      lojas: arr
    });

    this.selectedStores = arr;
  }

  equipmentsValues(arr) {
    this.newService.patchValue({
      cdArea: arr[0].cdArea,
      cdProduto: arr[0].cdProduto,
      vlMaxManutencao: arr[0].vlMaxManutencao,
      vlMaxMaterial: arr[0].vlMaxMaterial
    });

    this.relatedEquipments = arr;
  }

  resetValues() {
    this.newService.patchValue({
      cdFornecedor: "",
      lojas: "",
      cdArea: "",
      cdProduto: "",
      vlMaxManutencao: 0,
      vlMaxMaterial: 0,
      cdsImpostoSap: "",
      dsComplementoSap: "",
      dsOperacaoSap: "",
      dsProjetoSap: "",
      flNovaLoja: 0
    });

    this.selectedStores = [];
    this.relatedEquipments = [
      {
        cdArea: "",
        cdProduto: "",
        vlMaxManutencao: 0,
        vlMaxMaterial: 0
      }
    ];
  }

  addNewService() {
    this.loadingBarService.start();

    this.servicesService.addService(this.newService.value).subscribe((response) => {
      this.loadingBarService.complete();

      this.resetValues();

      Swal({
        type: "success",
        title: "Serviço cadastrado",
        text: "O serviço será exibido na listagem",
        confirmButtonText: "Ok, entendi!",
        confirmButtonClass: "sweet-button",
        buttonsStyling: false
      }).then((result) => {
        this.router.navigate([this.urlBack]);
      });
    });
  }

}
